import * as React from "react"
import { useTranslation } from "react-i18next"

import DeleteButton from "Catalog/Edit/shared/components/CatalogToolbar/DeleteButton"
import NewButton from "Catalog/Edit/shared/components/CatalogToolbar/NewButton"
import CatalogToolbar from "Catalog/shared/components/CatalogToolbar"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { IDiscount } from "shared/hubrise/models"

interface ToolbarProps {
  discount?: IDiscount
}

const Toolbar = ({ discount }: ToolbarProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const handleCreate = (name: string): void => {
    const newDiscount = editor.discount.add(discount, { name })
    navigate(catalogNavigation.editPath("discount", newDiscount.id))
  }

  const handleDelete = (discount: IDiscount) => {
    navigate(catalogNavigation.editNextPath("discounts"))
    editor.discount.delete(discount.id)
  }

  const commandActions = (
    <>
      <NewButton handleCreate={handleCreate} labelAndTitle={t("toolbar.new.discount")} />
      <DeleteButton item={discount} handleDelete={handleDelete} />
    </>
  )

  return <CatalogToolbar commandActions={commandActions} />
}

export default Toolbar
